module.exports = __webpack_public_path__ + "img/Contpaqi_white_leyenda.d84f01e6.svg";